import NoMatch from "components/no-match"
import { Routes, Route, Navigate } from "react-router-dom"
import EmailRegistration from "./email-registration"
import Registration from "./registration"

const ExternalMembers: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="email-registration" />} />
      <Route path="email-registration" element={<EmailRegistration />} />
      <Route path="registration" element={<Registration />} />

      <Route path="*" element={<NoMatch />} />
    </Routes>
  )
}

export default ExternalMembers
